// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import { CssBaseline, Box } from '@mui/material';

// Pages
import Vehicles from './pages/Vehicles';
import About from './pages/About';
import Login from './pages/Login';

// Components
import Navbar from './components/Navbar';
import IFrame from './pages/IFrame';

// Services
import AccountPage from './pages/Account';
import ResetPassword from './components/authentication/ForgotPasswordContainer';
import Logout from './pages/Logout';
import Redirect from './pages/Redirect';
import Billing from './pages/Billing';
import Reporting from './pages/Reporting';
import ClientDashboard from './pages/ClientDashboard';
import CsvDownloadPage from './pages/CsvDownloadPage';
import Systems from './pages/Systems';
import { ThemeProvider } from './context/ThemeContext';
import AssetPage from './pages/Asset';
import { SessionProvider } from './context/SessionContext';
import GlobalLoadingOverlay from './components/GlobalLoadingOverlay';

const AppContent: React.FC = () => {
  const location = useLocation();
  const isIframe = location.pathname.includes('/iframe');

  return (
    <Box sx={{ width: "100vw", height: "100vh", overflow: "hidden", display: "flex", flexDirection: "column" }}>
     {!isIframe && <Navbar />}

      <GlobalLoadingOverlay />
      <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/resetPassword" element={<ResetPassword />} />

          {/* Iframe Routes - No authentication required */}
          <Route path="/iframe/:clientId/:assetId" element={<IFrame />} />
          <Route path="/iframe/:clientId/:assetId/:image_type" element={<IFrame />} />
          <Route path="/iframe/*" element={<Navigate to="/" replace />} />

          {/* Protected Routes */}
          <Route path="/" element={<Redirect />} />
          <Route path="/vehicles" element={<Vehicles />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/reporting" element={<Reporting />} />
          <Route path="/client-dashboard" element={<ClientDashboard />} />
          <Route path="/systems" element={<Systems />} />
          <Route path="/about" element={<About />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/vehicle/:clientId/:assetId" element={<AssetPage />} />
          <Route path="/csv-download" element={<CsvDownloadPage />} />


          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Box>
    </Box>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <CssBaseline />
      <Router>
        <SessionProvider>
          <AppContent />
        </SessionProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;
